module.exports = window["Bernie_l10nBundle_sk_SK"];